<template>
<div class="row">
    <div class="large-5 columns"> <img src="static/imgs/28719-640-transp.png" alt=""> </div>
    <div class="large-7 columns top">
        <div class="panel" @keyup.enter="lostLogin" id="lostlogin-page">
            <div class="panel-title"> Mot de passe perdu ?
                <hr>
            </div>
            <div v-if="requestStatus === null || requestStatus != 200" class="panel-content">
                    <div class="row columns">
                        <div class="large-12 columns">
                            <label >Saisissez votre adresse email </label>
                            <div class="notes">un mail de changement de mot de passe vous sera envoyé</div>
                        </div>
                    </div>
                    <br>
                    <div class="row columns">
                        <div class="large-12 columns">
                          <p :class="{ 'control': true }">
                            <input v-validate="'required|email'"
                              v-model="email"
                              :class="{'input': true, 'invalid': errors.has('email'),
                              'valid':!errors.has('email'),
                              'untouched':errors.count()==0 }" name="email" type="text" placeholder="Email">
                            <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
                          </p>
                        </div>
                    </div>
                    <br>
                    <spinner v-if="requestSent"></spinner>
                    <div class="row columns">
                        <div class="large-4 columns">
                            <router-link to="home"><button class="full-width light-grey-button">Retour</button></router-link>
                        </div>
                        <div class="large-4 columns">
                            <button
                            @click="lostLogin"
                            :disabled="!submissionEnabled"
                            class="full-width">Valider</button>
                        </div>
                    </div>
            </div>
            <div v-if="requestStatus === 200" class="panel-content">
                <div class="row columns">
                    <div class="large-12 columns large-centered">
                        <h3>C'est parti !</h3>
                        <div>Vérifiez votre boite mail et vos spams, vous allez recevoir un mail de changement de mot de passe</div>
                    </div>
                </div>
                <br>
                <br>
                <div class="row">
                    <div class="large-4 large-centered columns">
                        <router-link to="home"><button class="full-width light-grey-button">Retour</button></router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import auth from '../../api/auth.api'
import spinner from '../common/spinner.vue'
import store from '../../store/index.js'

export default {
  name: 'lostLogin',
  components: {
    spinner
  },
  computed:
  {
    submissionEnabled: function () {
      if (this.email === null || this.errors.has('email')) {
        return false
      }
      return true
    }
  },
  data () {
    return {
      email: null,
      requestSent: false,
      requestStatus: null
    }
  },
  created () {
    store.dispatch('hideLeaguePanel')
    store.dispatch('deactivateFullSizePage')
  },
  methods: {
    lostLogin () {
      if (this.email === null || this.errors.has('email')) {
        return
      }
      this.requestSent = true
      auth.api.lostLogin(this.email)
      .then(response => {
        this.requestSent = false
        this.requestStatus = response.status
      },
      error => {
        this.requestSent = false
        this.requestStatus = error.status
        if (this.requestStatus === 400) {
          this.errors.add('email', 'erreur interne, veuillez contacter l\'admin', 'auth')
          this.errors.first('email:auth')
        } else {
          this.errors.add('email', 'Impossible d\'éxécuter la requête', 'auth')
          this.errors.first('email:auth')
        }
      })
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login-error {
  text-align: center;
  color: #CC0000;
}

.form-group {
  border-radius: 8px;
}

.notes {
  font-size: 0.7rem;
  font-weight: 300;
  color: #2F353B;
  text-align: left;
}

label {
  font-size: 1rem;
  color: #2F353B;
  font-weight: 500;
  text-align: left;
}

.is-danger {
  color:#E7505A;
}

.message {
  margin-top: 0.4rem;
  margin-left: 0rem;
  padding-left: 0rem;
  font-size: 0.9rem;
  text-align: left;
}

input.invalid{
  border-left: 3px solid #a94442;
}

input.valid{
  border-left: 3px solid #42A948; /* green */
}

input.untouched{
  border-left: 3px solid #ACB5C3;
}
</style>



// WEBPACK FOOTER //
// lost-login.vue?afbaa718